import React from 'react';
import { testimonials } from '../../data/mock';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="kundenstimmen" className="py-20 bg-slate-900 scroll-mt-16">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-blue-400 font-semibold text-sm uppercase tracking-wider">Kundenstimmen</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 mb-4">
            Was unsere Kunden sagen
          </h2>
          <p className="text-slate-400">
            Über 10.000 zufriedene Kunden vertrauen bereits auf unseren Service.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50 hover:border-blue-500/30 transition-all duration-300 group"
            >
              <Quote className="w-8 h-8 text-blue-500/30 mb-4" />
              
              <p className="text-slate-300 text-sm leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < testimonial.rating
                        ? 'text-amber-400 fill-current'
                        : 'text-slate-600'
                    }`}
                  />
                ))}
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center text-white text-sm font-bold">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="text-white font-medium text-sm">{testimonial.name}</p>
                  <p className="text-slate-500 text-xs">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: '10.000+', label: 'Zufriedene Kunden' },
            { value: '500+', label: 'Partnerbanken' },
            { value: '98%', label: 'Weiterempfehlung' },
            { value: '24h', label: 'Schnelle Bearbeitung' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-blue-400 mb-2">{stat.value}</p>
              <p className="text-slate-400 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
